/* eslint-disable react/no-danger */
import React, { useEffect } from 'react'

// Pre-initialize the clarity queue with consent=false so it doesn't collect
// before the user has made a choice. Cookiebot events will update this.
// This stub is cheap and must run early to capture consent + buffer calls.
const CLARITY_CONSENT_INIT = `
(function(){
  window.clarity = window.clarity || function(){
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  clarity('consent', false);
  window.addEventListener('CookiebotOnAccept', function() {
    if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics) {
      clarity('consent');
      clarity('start');
    }
  });
  window.addEventListener('CookiebotOnDecline', function() {
    clarity('consent', false);
    clarity('stop');
  });
})();
`

const Clarity = () => {
  // The Clarity tag (~230ms of main-thread work that instruments every
  // interaction) is the heavy part. Defer loading it until the page is idle or
  // the user first interacts — whichever comes first — so it never inflates INP
  // on early interactions. Recording stays consent-gated via the init above.
  useEffect(() => {
    if (!process.env.CLARITY_SITE_ID) return undefined

    let triggered = false
    let timer
    const events = ['scroll', 'pointerdown', 'keydown', 'touchstart']

    const cleanup = () => {
      events.forEach((event) => window.removeEventListener(event, trigger))
      clearTimeout(timer)
      window.removeEventListener('load', arm)
    }

    function trigger() {
      if (triggered) return
      triggered = true
      cleanup()
      if (document.getElementById('clarity-tag')) return
      const script = document.createElement('script')
      script.id = 'clarity-tag'
      script.async = true
      script.src = `https://www.clarity.ms/tag/${process.env.CLARITY_SITE_ID}`
      document.head.appendChild(script)
    }

    // Arm the triggers only after the page has loaded, so the deferral window
    // can never open before first paint.
    function arm() {
      events.forEach((event) =>
        window.addEventListener(event, trigger, { once: true, passive: true })
      )
      timer = setTimeout(trigger, 3000)
    }

    if (document.readyState === 'complete') arm()
    else window.addEventListener('load', arm, { once: true })

    return cleanup
  }, [])

  if (!process.env.CLARITY_SITE_ID) return null

  return <script dangerouslySetInnerHTML={{ __html: CLARITY_CONSENT_INIT }} />
}

export default Clarity
